import { EmailEventInterface } from './email-event.interface';

export enum DistributionReportStat {
    SENT = 'SENT',
    DELIVERED = 'DELIVERED',
    RELIABLE_RECIPIENTS = 'RELIABLE_RECIPIENTS',
    MPP_RECIPIENTS = 'MPP_RECIPIENTS',
    UNIQUE_CLICKS = 'UNIQUE_CLICKS',
    UNIQUE_OPEN = 'UNIQUE_OPEN',
    RELIABLE_UNIQUE_OPEN = 'RELIABLE_UNIQUE_OPEN',
    MPP_OPEN = 'MPP_OPEN',
    REPLY = 'REPLY',
    UNOPENED = 'UNOPENED',
    SOFT_BOUNCED = 'SOFT_BOUNCED',
    BLOCKED = 'BLOCKED',
    UNSUBSCRIBED = 'UNSUBSCRIBED',
    PREVIOUS_UNSUB = 'PREVIOUS_UNSUB',
    HARD_BOUNCED = 'HARD_BOUNCED',
    SPAM_REPORT = 'SPAM_REPORT',
    OPENS = 'OPENS',
    CLICKS = 'CLICKS',
    REJECT = 'REJECT',
    NOT_SENT = 'NOT_SENT',
    PENDING = 'PENDING',
    PREVIOUS_SOFT_BOUNCED = 'PREVIOUS_SOFT_BOUNCED',
    PREVIOUS_SPAM_REPORT = 'PREVIOUS_SPAM_REPORT',
    PREVIOUS_HARD_BOUNCED = 'PREVIOUS_HARD_BOUNCED',
    RELIABLE_UNIQUE_CLICKS = 'RELIABLE_UNIQUE_CLICKS',
    MPP_CLICKS = 'MPP_CLICKS',
    TOTAL_MPP_CLICKS = 'TOTAL_MPP_CLICKS',
}

/**
 * Stores the relevant stats in priority order
 */
export const distributionReportRelevantStatHierarchy: DistributionReportStat[] = [
    DistributionReportStat.SPAM_REPORT,
    DistributionReportStat.UNSUBSCRIBED,
    DistributionReportStat.REPLY,
    DistributionReportStat.UNIQUE_CLICKS,
    DistributionReportStat.UNIQUE_OPEN,
    DistributionReportStat.RELIABLE_UNIQUE_CLICKS,
    DistributionReportStat.MPP_CLICKS,
    DistributionReportStat.TOTAL_MPP_CLICKS,
    DistributionReportStat.RELIABLE_UNIQUE_OPEN,
    DistributionReportStat.MPP_OPEN,
    DistributionReportStat.HARD_BOUNCED,
    DistributionReportStat.SOFT_BOUNCED,
    DistributionReportStat.REJECT,
    DistributionReportStat.DELIVERED,
    DistributionReportStat.RELIABLE_RECIPIENTS,
    DistributionReportStat.MPP_RECIPIENTS,
    DistributionReportStat.PREVIOUS_UNSUB,
    DistributionReportStat.PREVIOUS_SOFT_BOUNCED,
    DistributionReportStat.PREVIOUS_SPAM_REPORT,
    DistributionReportStat.PREVIOUS_HARD_BOUNCED,
    DistributionReportStat.BLOCKED,
    DistributionReportStat.SENT,
    DistributionReportStat.PENDING,
];

export interface RecipientReportSeriesApiModel {
    total: number;
    stats: Partial<Record<DistributionReportStat, number>>;
}

export interface IndividualRecipientReportApiModel extends RecipientReportSeriesApiModel {
    listId?: number;
    searchId?: number;
    mailingListId?: number;
    filter?: any;
    email?: string;
    events?: EmailEventInterface[];
}

export interface LinkText {
    clickedLinkText: string;
    clickedUrl: string;
    totalClicks: number;
    uniqueClicks: number;
}


export interface DistributionRecipientReportApiModel extends RecipientReportSeriesApiModel{
    individualRecipientReports: IndividualRecipientReportApiModel[];
    mailingListReports?: MailingListReportApiModel[];
    standaloneRecipientReport?: StandaloneRecipientReportApiModel;
    linkTexts?: LinkText[];
}

export interface MailingListReportApiModel extends RecipientReportSeriesApiModel {
    name: string;
    mailingListId: number;
    individualRecipientReports: IndividualRecipientReportApiModel[];
}

export interface StandaloneRecipientReportApiModel extends RecipientReportSeriesApiModel {
    individualRecipientReports: IndividualRecipientReportApiModel[];
}

